(function () {
  function injectFont() {
    const container = document.querySelector('[data-bv-show="reviews"]');
    if (!container || !container.shadowRoot) return false;

    if (container.shadowRoot.querySelector('#bv-font-override')) return true;

    const style = document.createElement('style');
    style.id = 'bv-font-override';
    style.textContent = `
      * {
        font-family: "Font-1765562304925", sans-serif !important;
      }
    `;

    

    container.shadowRoot.appendChild(style);
    return true;
  }

  if (injectFont()) return;

  let remainingAttempts = 200;
  const interval = setInterval(() => {
    remainingAttempts -= 1;
    if (injectFont() || remainingAttempts <= 0) {
      clearInterval(interval);
    }
  }, 300);

  window.addEventListener('pagehide', () => clearInterval(interval), { once: true });
})();
